/**
 * Unfortunately, we need to use the global version of Prism until this bug is resolved:
 *
 * https://github.com/mAAdhaTTah/babel-plugin-prismjs/issues/22
 *
 * That bug prevents us from specifying which languages we need via https://github.com/mAAdhaTTah/babel-plugin-prismjs
 *
 * At the time of writing this, we still use Prism in the legacy angularjs UI and so the correct set of
 * languages is already included. This means we cannot write tests for this new module, but it will be available
 * in our new React UI.
 */

declare global {
  interface Window {
    readonly Prism: any
  }
}

const Prism: undefined | any = window.Prism || {
  languages: {},
  highlight: (str) => str
}

export const highlight = (str: string, language: string) => {
  const grammar = Prism.languages[language.toLowerCase()]
  return Prism.highlight(str, grammar, language.toLowerCase())
}
